import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../../../components/icon/iconfont'
import ApplePayButton from '../../../../../components/applepay-button'
import { SensorsTrack } from '../../../../../../../utils/sensor'

export default props => {
    useStyles(classes)
    const {onPaymethod, onError, payMethodInfo, orderTotal, country, onRenderError, isFastPayment, check, clickHandle} = props

    const eventClick = () => {
        SensorsTrack('CartAction', {
            action: `ClickPayNow_${payMethodInfo?.id}`
        })
        clickHandle?.()
    }

    return <div className={classes.Apple}>
        <div className={classes.Button}>
            <ApplePayButton check={check} isFastPayment={isFastPayment} onRenderError={onRenderError} onError={onError} shoudBilling payMethod={payMethodInfo?.id} orderTotal={orderTotal} country={country} clickHandle={eventClick}/>
        </div>
        <button className={classes.Select} onClick={onPaymethod}>
            <Iconfont className={classes.Icon}>&#xe727;</Iconfont>
        </button>
    </div>
}